import React, { PropTypes, Component } from 'react';
import { Divider } from 'material-ui';
import { connect } from 'react-redux';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import CancellationPolicy from '../../contract-policies/policies/cancellation';
import GroupPolicy from '../../contract-policies/policies/group';
import FreeOfChargePolicy from '../../contract-policies/policies/freeofcharge';
import FamilyPolicy from '../../contract-policies/policies/family';
import ChildPolicy from '../../contract-policies/policies/child';
import InfantPolicy from '../../contract-policies/policies/infant';
import R, { equals } from 'ramda';
const policiesInCaps = {
  cancellation: 'Cancellation',
  group: 'Group',
  freeOfCharge: 'Free of Charge',
  family: 'Family',
  child: 'Child',
  infant: 'Infant',
};

const propTypes = {
  openAddEditContractDialog: PropTypes.func,
  deletePolicy: PropTypes.func,
  supplierEditable: PropTypes.bool,
  contractState: PropTypes.string,
  existingSeasons: PropTypes.array,
  contractingPeriod: PropTypes.object,
  productPolicy: PropTypes.array,
  productType: PropTypes.string,
};

class Policies extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }

  render() {
    const {
      openAddEditContractDialog,
      deletePolicy,
      supplierEditable,
      productPolicy,
      existingSeasons,
      contractingPeriod,
      productType,
    } = this.props;
    if (R.isEmpty(contractingPeriod)) return <div />;

    const policyObject =
      productPolicy && productPolicy.length
        ? productPolicy.reduce((result, policy) => {
            if (equals(policy.policyType, 'child')) {
              result.child = {
                ...policy,
                focChildrenAllowed: Boolean(policy.focChildrenCount),
              };
            } else result[policy.policyType] = policy;
            return result;
          }, {})
        : {};
    const getEditStateInfo = (policyType, action) => {
      return {
        type: 'editProductPolicy',
        title: `${action} Product ${policiesInCaps[policyType]} Policy`,
        policyType,
      };
    };
    const propsForCancellation = {
      supplierEditable,
      deletePolicy: () => deletePolicy('cancellation'),
      cancellationInfo: policyObject.cancellation,
      existingSeasons,
      openAddEditContractDialog,
      contractingPeriod,
      addCancellation: () =>
        openAddEditContractDialog({
          type: 'seasonalCancelPolicies',
          title:
            productType === 'Non-Accommodation'
              ? 'Add Product Specific Cancellation Policies'
              : 'Add Season Specific Cancellation Policies',
        }),
      editCancellation: () =>
        openAddEditContractDialog({
          type: 'seasonalCancelPolicies',
          title:
            productType === 'Non-Accommodation'
              ? 'Edit Product Specific Cancellation Policies'
              : 'Edit Season Specific Cancellation Policies',
        }),
    };
    const groupInfo = policyObject.group;
    const freeOfChargeInfo = policyObject.freeOfCharge;
    const familyInfo = policyObject.family;
    const childInfo = policyObject.child;
    const infantInfo = policyObject.infant;
    const getProps = type => {
      return {
        supplierEditable,
        deletePolicy: () => deletePolicy(type),
        [`add${type === 'freeOfCharge' ? 'FreeOfCharge' : policiesInCaps[type]}`]: () =>
          openAddEditContractDialog(getEditStateInfo(type, 'Add')),
        [`edit${type === 'freeOfCharge' ? 'FreeOfCharge' : policiesInCaps[type]}`]: () =>
          openAddEditContractDialog(getEditStateInfo(type, 'Edit')),
      };
    };
    const showAddButton = !groupInfo || !freeOfChargeInfo || !childInfo || !infantInfo;
    return (
      <div>
        <Divider style={{ marginTop: '24px', marginBottom: '24px' }} />
        <CancellationPolicy
          label={
            productType === 'Non-Accommodation'
              ? 'PRODUCT SPECIFIC CANCELLATION POLICY'
              : 'SEASONAL CANCELLATION POLICIES'
          }
          {...propsForCancellation}
        />
        <Divider style={{ marginTop: '24px', marginBottom: '24px' }} />
        <div style={{ marginBottom: '12px', marginTop: '12px' }}>
          <b>OTHER {productType === 'Non-Accommodation' ? 'PRODUCT' : 'ROOM'} POLICIES</b>
        </div>
        {groupInfo ? <GroupPolicy {...getProps('group')} groupInfo={groupInfo} /> : undefined}
        {groupInfo ? <br /> : undefined}
        {freeOfChargeInfo ? (
          <FreeOfChargePolicy {...getProps('freeOfCharge')} freeOfChargeInfo={freeOfChargeInfo} />
        ) : undefined}
        {freeOfChargeInfo ? <br /> : undefined}
        {familyInfo ? <FamilyPolicy {...getProps('family')} familyInfo={familyInfo} /> : undefined}
        {familyInfo ? <br /> : undefined}
        {childInfo ? <ChildPolicy {...getProps('child')} childInfo={childInfo} /> : undefined}
        {childInfo ? <br /> : undefined}
        {infantInfo ? <InfantPolicy {...getProps('infant')} infantInfo={infantInfo} /> : undefined}
        {infantInfo ? <br /> : undefined}
        {showAddButton ? (
          <AddItemCard
            onClick={() =>
              openAddEditContractDialog({ type: 'addProductPolicy', title: 'Add Product Policy' })
            }
            text={`Add ${
              productType === 'Non-Accommodation' ? 'product' : 'room'
            } specific policies`}
            editable={supplierEditable}
          />
        ) : undefined}
      </div>
    );
  }
}

Policies.propTypes = propTypes;

const mapStateToProps = ({ contracting }) => {
  const docContainer = contracting.contractActivitiesProducts.toJS();
  return {
    productPolicy: R.pathOr([], ['rightSideContent', 'productPolicy'], docContainer),
  };
};
export default connect(mapStateToProps)(Policies);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/right-column/right-policies.jsx